
export const getLanguageClass = (text) => {
    if (!text) return "english-text-bold-info"; // default to English style if text is empty or undefined

    const isBangla = /[\u0980-\u09FF]/.test(text);
    return isBangla ? "bangla-text-bold-info" : "english-text-bold-info";
};

export const replaceUnderscores = (text) => {
    if (!text) return '';
    return String(text).replace(/_/g, ' ');
};

export const SifTemplate = (SifInfo, qrText) => {
    const { personal, academic, guardian, admission, xadmission } = SifInfo;

     const html = `
<style>
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Tiro+Bangla:ital@0;1&family=Victor+Mono:ital,wght@0,500;1,500&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-size: 12px;
  line-height: 1.3;
  color: black;
  background-color: white;
}

.bangla-text { font-family: "Tiro Bangla", serif; font-weight: 400; }
.bangla-text-bold { font-family: "Tiro Bangla", serif; font-weight: 500; }
.bangla-text-bold-h1 { font-family: "Tiro Bangla", serif; font-weight: 800; }
.english-text { font-family: "Roboto Condensed", sans-serif; font-weight: 400; }
.english-text-bold { font-family: "Roboto Condensed", sans-serif; font-weight: 700; }


.bangla-text-info { font-family: "Tiro Bangla", serif; font-weight: 400;font-size: 13px; }
.bangla-text-bold-info { font-family: "Tiro Bangla", serif; font-weight: 500;font-size: 13px; font-weight: bold; }

.english-text-info { font-family: "Roboto Condensed", sans-serif; font-weight: 400;font-size: 13px; }
.english-text-bold-info { font-family: "Roboto Condensed", sans-serif; font-weight: 700; font-size: 13px;}

.container { width: 100%; padding: 0 40px; margin: auto; }
.row { display: flex; flex-wrap: wrap; margin: 0; }
.col-md-2, .col-md-3, .col-md-6, .col-md-7, .col-md-8, .col-md-12 {
  padding: 0 5px;
  margin-bottom: 5px;
}
.col-md-2 { flex: 0 0 16.6667%; max-width: 16.6667%; }
.col-md-3 { flex: 0 0 25%; max-width: 25%; }
.col-md-6 { flex: 0 0 50%; max-width: 50%; }
.col-md-7 { flex: 0 0 58.3333%; max-width: 58.3333%; }
.col-md-8 { flex: 0 0 66.6667%; max-width: 66.6667%; }
.col-md-12 { flex: 0 0 100%; max-width: 100%; }

.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }
.font-weight-bold { font-weight: bold; }

.university-name {
  font-size: 27px;
  line-height: 1.4;
  margin-bottom: 2px;
}
.admission-title { font-size: 14px; margin-bottom: 5px; }
.university-logo { max-width: 100%; height: auto; max-height: 100px; }

.qrcode {  margin: auto; }


/* Card container */
.info-card {
  background: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  align-items: stretch;
}

/* Photo section */
.info-photo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.student-photo {
  width: 100%;
  max-width: 120px;
  height: 120px;
  object-fit: cover;
  border: 1px solid #999;
  background: #fff;
}

/* Text sections */
.info-details {
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Each row */
.info-item {
  margin-bottom: 6px;
  line-height: 1.4;
}

/* Labels */
.info-item .label {
  display: block;
  font-family: 'Tiro Bangla', serif;
  font-size: 12px;
  color: #333;
}

/* Values */
.info-item .value {
  font-family: 'Times New Roman', Times, serif;
  font-size: 13px;
  font-weight: bold;
  color: #000;
}

/* Unit styling */
.unit {
  font-weight: normal;
  font-size: 12px;
  margin-left: 4px;
}

/* Print stability */
@media print {
  .info-card {
    break-inside: avoid;
  }

  .academic-grid {
    break-inside: avoid;
  }
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* One ROW = left + right */
.info-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  min-height: 40px;
  background: transparent;
  border: 1px solid #ccc;
}

/* Cell */
.info-cell {
  padding: 3px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid #ccc;
}

.info-cell:last-child {
  border-right: none;
}

.info-numbered-row {
  display: flex;
  align-items: flex-start;  /* number aligns to top of content */
  gap: 8px;                  /* space between number & content */
  margin-bottom: 8px;        /* spacing between rows */
}

.info-numbered-row .number {
  flex: 0 0 3%;              /* fixed width for number */
  font-weight: bold;
  text-align: right;
}

.info-numbered-row .content {
  flex: 1;                    /* content takes remaining space */
}


.label {
  font-family: 'Tiro Bangla', serif;
  font-size: 12px;
  color: #333;
}

.value {
  font-family: 'Times New Roman', serif;
  font-size: 13px;
  font-weight: bold;
}

/* Keep height even if empty */
.value:empty::after {
  content: '\x00a0';
}

/* Photo unchanged */
.info-photo {
  display: flex;
  align-items: center;
  justify-content: center;
}



.info-section {
  background: rgb(240, 240, 240);
}
.info-section p {
  font-size: 16px;
  color: black;
  font-family:  'Tiro Bangla', serif;
}
.info-label {
  font-family:  'Tiro Bangla', serif;
}
.info-value {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
}
.numbered-item {
  display: flex;
  margin-bottom: 8px;
}
.number {
  flex: 0 0 3%;
  vertical-align: top;
}
.content {
  flex: 0 0 97%;
}
.indented-content { margin-left: 25px; }
.deep-indented-content { margin-left: 45px; }

p { margin: 2px 0; }
.font-14 { font-size: 14px; }
.font-12 { font-size: 13px; }

/* “Table look” but with only DIVs */
.academic-table {
  width: 100%;
  margin-top: 8px;
  border: 1px solid #8abbd9;
  border-radius: 2px;
  font-size: 13px;
  overflow: visible; /* 🔥 critical fix */
}

.academic-row {
  display: flex;
  width: 100%;
}

.academic-row.header {
  background-color: #d1ecf1;
  font-weight: bold;
}

.academic-cell {
  padding: 6px 8px;
  border-right: 1px solid #8abbd9;
  border-top: 1px solid #8abbd9;
}

.academic-row:first-child .academic-cell {
  border-top: none;
}

.academic-row .academic-cell:last-child {
  border-right: none;
}

/* column widths */
.academic-col-exam  { flex: 0 0 18%; }
.academic-col-inst  { flex: 0 0 32%; }
.academic-col-board { flex: 0 0 30%; }
.academic-col-year  { flex: 0 0 10%; text-align: center; }
.academic-col-gpa   { flex: 0 0 10%; text-align: center; }


.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  opacity: 0.6;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: -1;
}


/* spacing helpers (Bootstrap-like) */
.mt-1 { margin-top: .25rem; }
.mt-2 { margin-top: .5rem; }
.mt-3 { margin-top: 1rem; }
.mt-5 { margin-top: 3rem; }
.mb-1 { margin-bottom: .25rem; }
.mb-5 { margin-bottom: 3rem; }
.ms-3 { margin-left: 1rem; }
.ms-4 { margin-left: 1.5rem; }
.ms-5 { margin-left: 3rem; }
.me-2 { margin-right: .5rem; }
.ps-3 { padding-left: 1rem; }


.signature-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.signature-col {
  flex: 0 0 48%;
}

.signature-row-3 {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.signature-col-3 {
  flex: 0 0 32%;
}


/* Force A4 page size for print */
@page {
  size: A4;
  margin: 15mm 10mm;
}

.page {
  position: relative;
  page-break-after: always;
}
.page-a4{
  height: auto;
}

.academic-table.compact {
  border: 1px solid #8abbd9;
  margin-top: 6px;
  font-size: 12px;
}

.academic-grid {
  display: grid;
  grid-template-columns: 16% 32% 28% 12% 12%;
  border-top: 1px solid #8abbd9;
}

.academic-grid:first-child {
  border-top: none;
}

.academic-grid > div {
  padding: 4px 6px;
  border-right: 1px solid #8abbd9;
}

.academic-grid > div:last-child {
  border-right: none;
}

.academic-grid.header {
  background: #d1ecf1;
  font-weight: bold;
}


.section {
    margin-top: 12px;
}

.section-lg {
    font-size:20px;
    text-align: center;
}

.section-content{
    font-size:14px;
}

.indent {
    margin-left: 20px;
}

.signature-row {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 25px;
}

.signature-col {
    width: 50%;
    text-align: center;
    font-size: 13px;
}

.signature-line {
    margin-bottom: 5px;
}


.approval-row {
    display: flex;
    align-items: center; 
    justify-content: space-between;
    margin-top: 30px;
    
    width: 100%;
}
.approval-col-left {
    width: 45%;
}
.approval-col-right {
    width: 45%;
}



.small-note {
    font-size: 12px;
    font-style: italic;
    margin-top: 8px;
}


.signature-row-3 {
    display: flex;
    justify-content: space-between;
    margin-top: 35px;
}

.signature-col-3 {
    width: 32%;
    text-align: center;
    font-size: 13px;
}



</style>

<div class="sif-generator-wrapper">
<section class="event team-sec team-grid speaker set-relative py-5" id="speaker">
  <div class="container">

    <!-- PAGE 1 -->
    <div class="page page-a4" style="top:-15px;">
    
      <img src="https://cu-admission.sgp1.cdn.digitaloceanspaces.com/logo/cu_watermark.png" class="watermark">

      <!-- Header -->
      <div class="row" style="height: 104px;">
        <div class="col-md-2 text-left" style="position:relative;left:-5px;">
          <img alt="Logo" class="university-logo" src="https://cu-admission.sgp1.digitaloceanspaces.com/logo/admit_logo.png">
        </div>
        <div class="col-md-8 text-center" style="padding-top: 20px;">
          <div class="bangla-text-bold university-name">চট্টগ্রাম বিশ্ববিদ্যালয়</div>
          <div class="bangla-text admission-title">১ম বর্ষ স্নাতক ( সম্মান ) কোর্সে ছাত্র-ছাত্রী ভর্তির মূল ফর্ম</div>
        </div>
        <div class="col-md-2" style="position:relative;right:-15px;">
          <div class="qrcode" id="qrCodeUrl" ></div>
        </div>
      </div>

      <div class="row info-card">

        <!-- Photo -->
        <div class="col-md-3 info-photo text-center">
          <img alt="Student Photo" class="student-photo" src="${personal.photo}">
        </div>

        <!-- INFO GRID -->
        <div class="col-md-9 info-grid">

          <div class="info-row">
            <div class="info-cell">
              <span class="label">ভর্তির শিক্ষাবর্ষ</span>
              <span class="value english-text">${admission.session || '&nbsp;'}</span>
            </div>
            <div class="info-cell">
              <span class="label">ভর্তি পরীক্ষার রোল</span>
              <span class="value english-text">
                ${admission.exam_roll || '&nbsp;'}
                <span class="unit">( ${admission.unit || ''} )</span>
              </span>
            </div>
          </div>

          <div class="info-row">
            <div class="info-cell">
              <span class="label">বিষয়</span>
              <span class="value english-text-info">${admission.subject_name || '&nbsp;'}</span>
            </div>
            <div class="info-cell">
              <span class="label">ভর্তি পরীক্ষায় প্রাপ্ত নম্বর</span>
              <span class="value english-text">${admission.exam_score || '&nbsp;'}</span>
            </div>
          </div>

          <div class="info-row">
            <div class="info-cell">
              <span class="label">কোর্সের নাম</span>
              <span class="value english-text">${admission.course || '&nbsp;'}</span>
            </div>
            <div class="info-cell">
              <span class="label">জমাকৃত ভর্তি ফি’র পরিমাণ</span>
              <span class="value english-text">${admission.admission_fee || '&nbsp;'} Tk</span>
            </div>
          </div>

          <div class="info-row">
            <div class="info-cell">
              <span class="label">রেজিস্ট্রেশন / আই.ডি. নম্বর</span>
              <span class="value english-text">${admission.regino || '&nbsp;'}</span>
            </div>
            <div class="info-cell">
              <span class="label">ফি জমাদানের রসিদ নম্বর</span>
              <span class="value english-text">${admission.memo_receipt || '&nbsp;'}</span>
            </div>
          </div>

          <div class="info-row">
            <div class="info-cell">
              <span class="label">ফি জমাদানের তারিখ</span>
              <span class="value english-text">${admission.payment_date || '&nbsp;'}</span>
            </div>
            <div class="info-cell">
              <span class="label">&nbsp;</span>
              <span class="value">&nbsp;</span>
            </div>
          </div>

        </div>
      </div>

        <div style="z-index:1; position:relative; min-height: 750px;">
      
        <!-- 1 -->
        <div class="info-numbered-row bangla-text-info mt-2">
            <div class="number">১.</div>
            <div class="content">
            <div>
                ছাত্র / ছাত্রীর পুরো নাম ( বাংলায় ):
                <strong class="${getLanguageClass(personal.name_bng)}">${personal.name_bng}</strong>
            </div>
            <div class="english-text-info">
                <span class="bangla-text-info">( ইংরেজিতে বড় অক্ষরে ):</span>
                <strong class="${getLanguageClass(personal.name)}">${personal.name}</strong>
            </div>
            </div>
        </div>


        <!-- 2 -->
        <div class="info-numbered-row bangla-text-info mt-1">
            <div class="number">২.</div>
            <div class="content">
            <div>
                জাতীয় পরিচয়পত্র / জন্মনিবন্ধন নম্বর:
                <strong class="${getLanguageClass(personal.nid_brno)}">${personal.nid_brno}</strong>
            </div>
            
            </div>
        </div>
      

        <!-- 3 -->
        <div class="info-numbered-row bangla-text-info mt-1">
            <div class="number">৩.</div>
            <div class="content">
            <div>
                মোবাইল নম্বর:
                <strong class="${getLanguageClass(personal.mobile)}">${personal.mobile}</strong>
            </div>
            
            </div>
        </div>
      

        <!-- 4 (father) -->
        <div class="info-numbered-row bangla-text-info mt-1">
            <div class="number">৪.</div>
            <div class="content">
            <div>
                (ক) পিতার নাম ( বাংলায় ):
                <strong class="bangla-text-bold-info">${guardian.fname_bng}</strong>
            </div>
            <div class="english-text-info ml-4">
                <span class="bangla-text-info">( ইংরেজিতে বড় অক্ষরে ):</span>
                <strong class="${getLanguageClass(guardian.fname)}">${guardian.fname}</strong>
            </div>

            <div>
                (খ) পিতার জাতীয় পরিচয়পত্র <span class="english-text-info">( NID )</span> নম্বর:
                <strong class="${getLanguageClass(guardian.fnid_brno)}">${guardian.fnid_brno}</strong>
            </div>

            <div>
                (গ) পিতার বর্তমান পেশা, পদবী এবং প্রতিষ্ঠানের নাম ও ঠিকানা:
                <div class="ml-4 bangla-text">
                বর্তমান পেশা:
                <strong class="${getLanguageClass(guardian.foccupation)}">${guardian.foccupation}</strong>
                </div>

                <div class="ml-4 bangla-text">
                পদবী:
                <strong class="${getLanguageClass(guardian.fdesignation)}">${guardian.fdesignation}</strong>
                </div>

                <div class="ml-4 bangla-text">
                প্রতিষ্ঠানের নাম ও ঠিকানা:
                <strong class="${getLanguageClass(guardian.femployer_info)}">${guardian.femployer_info}</strong>
                </div>

            
            </div>

            <div>
                (ঘ) পিতার মোবাইল নম্বর:
                <strong class="${getLanguageClass(guardian.fmobile)}">${guardian.fmobile}</strong>
            </div>

            </div>
        </div>

        <!-- 5 (mother) -->
        <div class="info-numbered-row bangla-text-info mt-1">
            <div class="number">৫.</div>
            <div class="content">
            <div>
                (ক) মাতার পুরো নাম ( বাংলায় ):
                <strong class="${getLanguageClass(guardian.mname_bng)}">${guardian.mname_bng}</strong>
            </div>
            <div class="english-text-info ml-4">
                <span class="bangla-text-info">( ইংরেজিতে বড় অক্ষরে ):</span>
                <strong class="${getLanguageClass(guardian.mname)}">${guardian.mname}</strong>
            </div>

            <div>
                (খ) মাতার জাতীয় পরিচয়পত্র  <span class="english-text-info">( NID )</span> নম্বর:
                <strong class="${getLanguageClass(guardian.mnid_brno)}">${guardian.mnid_brno}</strong>
            </div>

            
            <div>
                (ঘ) মাতার মোবাইল নম্বর:
                <strong class="${getLanguageClass(guardian.mmobile)}">${guardian.mmobile}</strong>
            </div>

            </div>
        </div>


        <!-- 6 -->
        <div class="info-numbered-row bangla-text-info mt-1">
            <div class="number">৬.</div>
            <div class="content">
            <div>
                বৈবাহিক অবস্থা:
                <strong class="bangla-text-bold-info">${personal.is_married ? 'বিবাহিত' : 'অবিবাহিত'}</strong>
            </div>
            
            </div>
        </div>
      

        <!-- 7 (spouse) -->

        <div class="info-numbered-row bangla-text-info mt-1">
            <div class="number">৭.</div>
            <div class="content">
            <div>
                ( যদি বিবাহিত হন স্বামী / স্ত্রীর নাম, ঠিকানা এবং টেলিফোন / মোবাইল নম্বর ):
            </div>
            <div class="ml-4">
                স্বামী / স্ত্রীর নাম:
                <strong class="${getLanguageClass(personal.spouse_name)}">${personal.spouse_name}</strong>
            </div>

            <div class="ml-4">
                যোগাযোগের ঠিকানা:
                <strong class="${getLanguageClass(personal.spouse_address)}">${personal.spouse_address}</strong>
            </div>

            
            <div class="ml-4">
                টেলিফোন / মোবাইল নম্বর:
                <strong class="${getLanguageClass(personal.spouse_mobile)}">${personal.spouse_mobile}</strong>
            </div>

            </div>
        </div>
      

        <!-- 8 permanent address -->

        <div class="info-numbered-row bangla-text-info">
            <div class="number">৮.</div>
            <div class="content">
            <div>
                স্থায়ী ঠিকানা:
            </div>
            <div class="ml-4">
                বাড়ি / হোল্ডিং নম্বর:
                <strong class="${getLanguageClass(personal.both_address_same ? personal.present_house : personal.permanent_house)}">${personal.both_address_same ? personal.present_house : personal.permanent_house}</strong> , 
                গ্রাম / ওয়ার্ড / সড়ক:
                <strong class="${getLanguageClass(personal.both_address_same ? personal.present_village : personal.permanent_village)}">${personal.both_address_same ? personal.present_village : personal.permanent_village}</strong> , 
                ডাকঘর:
                <strong class="${getLanguageClass(personal.both_address_same ? personal.present_poffice : personal.permanent_poffice)}">${replaceUnderscores(personal.both_address_same ? personal.present_poffice : personal.permanent_poffice)}</strong> ,
                থানা / উপজেলা:
                <strong class="${getLanguageClass(personal.both_address_same ? personal.present_thana : personal.permanent_thana)}">${replaceUnderscores(personal.both_address_same ? personal.present_thana : personal.permanent_thana)}</strong> , 
                জেলা:
                <strong class="${getLanguageClass(personal.both_address_same ? personal.present_district : personal.permanent_district)}">${replaceUnderscores(personal.both_address_same ? personal.present_district : personal.permanent_district)}</strong> 

            </div>

            <div class="ml-4 bangla-text">
                মোবাইল নম্বর:
                <strong class="${getLanguageClass(personal.both_address_same ? personal.present_mobile : personal.permanent_mobile)}">${personal.both_address_same ? personal.present_mobile : personal.permanent_mobile}</strong>
            </div>

            </div>
        </div>

        <!-- 9 present address -->

        <div class="info-numbered-row bangla-text-info">
            <div class="number">৯.</div>
            <div class="content">
            <div>
                ছাত্র / ছাত্রীর সাথে যোগাযোগের বর্তমান ঠিকানা:
            </div>
            <div class="ml-4">
                বাড়ি / হোল্ডিং নম্বর:
                <strong class="${getLanguageClass(personal.present_house)}">${personal.present_house}</strong> , 
                গ্রাম / ওয়ার্ড / সড়ক:
                <strong class="${getLanguageClass(personal.present_village)}">${personal.present_village}</strong> , 
                ডাকঘর:
                <strong class="${getLanguageClass(personal.present_poffice)}">${replaceUnderscores(personal.present_poffice)}</strong> ,
                থানা / উপজেলা:
                <strong class="${getLanguageClass(personal.present_thana)}">${replaceUnderscores(personal.present_thana)}</strong> ,
                জেলা:
                <strong class="${getLanguageClass(personal.present_district)}">${replaceUnderscores(personal.present_district)}</strong>
     
            </div>

            <div class="ml-4 bangla-text">
                মোবাইল নম্বর:
                <strong class="${getLanguageClass(personal.present_mobile)}">${personal.present_mobile}</strong>
            </div>

            <div style="font-style: italic; color: red;font-size: 12px;text-align: justify;">
                বিশেষ দ্রষ্টব্যঃ বর্তমান ঠিকানা পরিবর্তন হলে এক সপ্তাহের মধ্যে বিভাগের সভাপতির মাধ্যমে বিশ্ববিদ্যালয়ের রেজিস্ট্রারকে লিখিতভাবে জানাতে হবে।
            </div>

            </div>
        </div>

        <!-- 10 local guardian -->
        <div class="info-numbered-row bangla-text-info ml-1">
            <div class="number">১০.</div>
            <div class="content">
            <div>
                স্থানীয় অভিভাবকের তথ্য:
            </div>
            <div class="ml-4 bangla-text-info">
                অভিভাবকের নাম:
                <strong class="${getLanguageClass(guardian.guardian_name)}">${guardian.guardian_name}</strong>
            </div>
            <div class="ml-4 bangla-text-info">
                ছাত্র / ছাত্রীর সাথে সম্পর্ক:
                <strong class="${getLanguageClass(guardian.guardian_relation)}">${guardian.guardian_relation}</strong>
            </div>
            <div class="ml-4 bangla-text-info">
                অভিভাবকের বর্তমান ঠিকানা:
                <strong class="${getLanguageClass(guardian.guardian_address)}">${guardian.guardian_address}</strong>
            </div>
            <div class="ml-4 bangla-text-info">
                অভিভাবকের টেলিফোন / মোবাইল নম্বর:
                <strong class="${getLanguageClass(guardian.guardian_mobile)}">${guardian.guardian_mobile}</strong>
            </div>

            </div>
        </div>

        

        </div>

      
      
    </div> <!-- end page 1 -->

      

      

    <!-- PAGE 2 -->
    <div class="page page-a4">
    
    <div style="z-index:1; position:relative; min-height: 1100px;padding: 0 10px;">
        <img src="https://cu-admission.sgp1.cdn.digitaloceanspaces.com/logo/cu_watermark.png" class="watermark">

     
        

        

        <!-- 11 -->
        <div class="info-numbered-row bangla-text-info  mt-5">
            <div class="number">১১.</div>
            <div class="content">
            <div>
                ধর্ম:
                <strong class="${getLanguageClass(personal.religion)}">${personal.religion}</strong>
                &nbsp;
                রক্তের গ্রুপ:
                <strong class="${getLanguageClass(personal.blood_group)}">${personal.blood_group}</strong>
                &nbsp;
                জাতীয়তা:
                <strong class="${getLanguageClass(personal.nationality)}">${personal.nationality}</strong>
            </div>
            
            </div>
        </div>

      

        <!-- 12 DOB -->
        <div class="info-numbered-row bangla-text-info mt-1">
            <div class="number">১২.</div>
            <div class="content">
            <div>
                মাধ্যমিক স্কুল সার্টিফিকেট অনুযায়ী জন্ম তারিখ:
                <strong class="${getLanguageClass(personal.dob)}">${personal.dob}</strong>
            
            </div>
            
            </div>
        </div>
      
        <!-- 13 BNCC -->
        <div class="info-numbered-row bangla-text-info mt-1">
            <div class="number">১৩.</div>
            <div class="content">
            <div>
                বি.এন.সি.সি. প্রশিক্ষনে / রোভার স্কাউটে যোগদানে ইচ্ছুক কিনা:
                <strong class="bangla-text-bold-info">${admission.interested_bncc ? 'হ্যাঁ' : 'না'}</strong>
            
            </div>
            
            </div>
        </div>

        <!-- 14 guardian income -->

        <div class="info-numbered-row bangla-text-info">
            <div class="number">১৪.</div>
            <div class="content">
            <div>
                পিতার / আইনতঃ অভিভাবকের আনুমানিক মাসিক আয় ( সংখ্যা ও কথায় ):
            </div>
            <div class="ml-4 bangla-text-info">
                মাসিক আয় ( সংখ্যায় ):
                <strong class="english-text-bold-info">${admission.guardian_income_number}/= Tk</strong>
                <span class="ml-3">
                মাসিক আয় ( কথায় ):
                <strong class="english-text-bold-info">${admission.guardian_income_word} Taka Only</strong>
                </span>
            </div>
            

            </div>
        </div>

        <!-- 15 academic info – “table” with DIVs only -->
        <div class="info-numbered-row bangla-text-info">
            <div class="number">১৫.</div>
            <div class="content">
            <div>
                আবেদনকারী যে সকল শিক্ষা প্রতিষ্ঠান হতে উত্তীর্ণ / অংশগ্রহন করেছেন তার বিবরণ
            </div>
            

            <div class="academic-table compact">
                <div class="academic-grid header bangla-text-info">
                    <div>পরীক্ষা</div>
                    <div>শিক্ষা প্রতিষ্ঠান</div>
                    <div>বোর্ড / কেন্দ্র / রোল</div>
                    <div>সন</div>
                    <div>জিপিএ</div>
                </div>

                <div class="academic-grid bangla-text-info">
                    <div class="english-text-info">SSC / Equivalent</div>
                    <div class="${getLanguageClass(academic.ssc_institute)}">${academic.ssc_institute}</div>
                    <div>
                    <div class="${getLanguageClass(academic.ssc_board)}">${academic.ssc_board}</div>
                    কেন্দ্র: <span class="${getLanguageClass(academic.ssc_center)}">${academic.ssc_center}</span>, রোল: <span class="${getLanguageClass(academic.ssc_roll)}">${academic.ssc_roll}</span>
                    </div>
                    <div class="${getLanguageClass(academic.ssc_year)}">${academic.ssc_year}</div>
                    <div class="${getLanguageClass(academic.ssc_gpa)}">${academic.ssc_gpa}</div>
                </div>

                <div class="academic-grid bangla-text-info">
                    <div class="english-text-info">HSC / Equivalent</div>
                    <div class="${getLanguageClass(academic.hsc_institute)}">${academic.hsc_institute}</div>
                    <div>
                    <div class="${getLanguageClass(academic.hsc_board)}">${academic.hsc_board}</div>
                    কেন্দ্র: <span class="${getLanguageClass(academic.hsc_center)}">${academic.hsc_center}</span>, রোল: <span class="${getLanguageClass(academic.hsc_roll)}">${academic.hsc_roll}</span>
                    </div>
                    <div class="${getLanguageClass(academic.hsc_year)}">${academic.hsc_year}</div>
                    <div class="${getLanguageClass(academic.hsc_gpa)}">${academic.hsc_gpa}</div>
                </div>
            </div>

            

            </div>
        </div>


        <!-- 16 – previous admission -->
        <div class="info-numbered-row bangla-text-info">
            <div class="number">১৬.</div>
            <div class="content">
            <div>
                 <div style="text-align: justify;">এ বিশ্ববিদ্যালয়ে বা অন্য কোন বিশ্ববিদ্যালয়ে বা কোন কলেজ / শিক্ষা প্রতিষ্ঠানে কোন কোর্সে ভর্তির পূর্বে ভর্তি হওয়ার পর ভর্তি ও রেজিস্ট্রেশনের মেয়াদ বহাল থাকলে বিবরণ উল্লেখ করতে হবে অথবা এ বিশ্ববিদ্যালয়ে ১ম বর্ষে প্রথম ভর্তির নিম্নোক্ত বিবরণ উল্লেখ করতে হবে:
                 </div>
                <span class="bangla-text-bold-info">${xadmission.is_admitted ? '' : 'প্রযোজ্য নহে।'}</span>
            </div>
            
            <div>
                (ক) কোর্সের নাম: <strong class="${getLanguageClass(xadmission.admitted_course)}">${xadmission.admitted_course}</strong>
            </div>
            <div>
                (খ) বিশ্ববিদ্যালয় / শিক্ষাপ্রতিষ্ঠান: <strong class="${getLanguageClass(xadmission.admitted_institute)}">${xadmission.admitted_institute}</strong>
            </div>
            <div>
                (গ) শিক্ষাবর্ষ: <strong class="${getLanguageClass(xadmission.admitted_session)}">${xadmission.admitted_session}</strong> <span class="ml-4">বিষয়: <strong class="${getLanguageClass(xadmission.admitted_subject)}">${xadmission.admitted_subject}</strong></span>
            </div>
            <div>
                (ঘ) ক্লাশ রোল নম্বর: <strong class="${getLanguageClass(xadmission.admitted_classroll)}">${xadmission.admitted_classroll}</strong> <span class="ml-4"> রেজিস্ট্রেশন / আই.ডি. নং: <strong class="${getLanguageClass(xadmission.admitted_regino)}">${xadmission.admitted_regino}</strong></span>
            </div>
            

            </div>
        </div>


        <!-- 17 – disciplinary -->
        <div class="info-numbered-row bangla-text-info">
            <div class="number">১৭.</div>
            <div class="content">
            <div style="text-align: justify;">
                <span style="color: red;">একজন ছাত্র / ছাত্রীর একাধিক কোর্সে ভর্তি <strong>( দ্বৈত ভর্তি )</strong> হওয়া অপরাধ।</span>
                এ ভর্তির পূর্বের সকল ভর্তি দশ দিনের মধ্যে বাতিলের আদেশপত্র ভর্তি ফর্ম এর সাথে সংযুক্ত করে দিতে হবে।
                <span style="color: red;"> বিশ্ববিদ্যালয়ের নিয়মে দ্বৈত ভর্তি হলে তার সকল ভর্তি অবৈধ হিসাবে গণ্য হবে এবং তাকে অন্যান্য শাস্তিও ভোগ করতে হবে।</span>
                 <span class="bangla-text-bold-info">${xadmission.is_postponed ? '' : 'প্রযোজ্য নহে।'}</span>
            </div>
            
            <div>
                (ক) অধ্যয়ন স্থগিত থাকলে তার কারণ উল্লেখ করতে হবে:
                <div class="ml-4">
                স্থগিত থাকার কারণ:
                <strong class="${getLanguageClass(xadmission.postponed_reason)}">${xadmission.is_postponed ? xadmission.postponed_reason : '&nbsp;'}</strong>
                </div>
            </div> 
            
            <div>
                (খ) এ বিশ্ববিদ্যালয় বা বা অন্য কোন বিশ্ববিদ্যালয় বা কোন কলেজ / শিক্ষা প্রতিষ্ঠান হতে কোন কারণে বহিষ্কৃত হয়েছে কিনা:
                <div class="ml-4">
                বহিষ্কারের কারণ:
                <strong class="${getLanguageClass(xadmission.expeled_reason)}">${xadmission.is_expeled ? xadmission.expeled_reason : '&nbsp;'}</strong>
                </div>
                <div class="ml-4">
                বহিষ্কার প্রদানকারী প্রতিষ্ঠান:
                <strong class="${getLanguageClass(xadmission.expeled_institute)}">${xadmission.is_expeled ? xadmission.expeled_institute + '</strong>, মেয়াদঃ <strong class="'+getLanguageClass(xadmission.expeled_period)+'">' + xadmission.expeled_period : '&nbsp;'}</strong>
                </div>
            </div>
            <div>
                <div style="text-align: justify;">
                (গ) পরীক্ষায় অসদুপায় অবলম্বনের কারণে বহিস্কৃত হলে বিষয়সহ পরীক্ষার নাম, পরীক্ষার বছর, পরীক্ষার রোল নম্বর, বহিস্কারের মেয়াদ, রেজিস্ট্রেশন / আই.ডি. নম্বর ইত্যাদি উল্লেখ করতে হবে: 
                </div>
                <div class="ml-4">
                    <strong class="${getLanguageClass(xadmission.expeled_examinfo)}">${xadmission.is_expeled ? xadmission.expeled_examinfo : '&nbsp;'}</strong>
            
                    </div>
            </div>
            

            </div>
        </div>

        <!-- 18 – residence -->
        <div class="info-numbered-row bangla-text-info">
            <div class="number">১৮.</div>
            <div class="content">
            <div>
                বিশ্ববিদ্যালয়ের আবাসিক হল এ থাকার ব্যবস্থা না হলে যেখানে থেকে লেখাপড়া করবেন তার ঠিকানা ( টেলিফোন / মোবাইল নম্বরসহ ):
                <span class="bangla-text-bold-info">${admission.self_residence ? '' : 'প্রযোজ্য নহে।'}</span>
            </div>
            
            <div class="ml-4">
                আবাসস্থলের ঠিকানা: <strong class="${getLanguageClass(admission.residence_address)}">${admission.residence_address}</strong>
            </div>
            <div class="ml-4">
                মোবাইল নম্বর: <strong class="${getLanguageClass(admission.residence_mobile)}">${admission.residence_mobile}</strong>
            </div>
        
            </div>
        </div>


        <!-- 19 – readmission -->
        <div class="info-numbered-row bangla-text-info">
            <div class="number">১৯.</div>
            <div class="content">
            <div>
                পুনঃভর্তি হলে তার বিবরণ:
                <strong class="bangla-text-bold-info">${xadmission.is_readmitted ? '' : 'প্রযোজ্য নহে।'}</strong>
            </div>
            <div class="ml-4">
                <strong class="${getLanguageClass(xadmission.readmission_reason)}">${xadmission.is_readmitted ? xadmission.readmission_reason : '&nbsp;'}</strong>
            </div>
            
            </div>
        </div>


        <!-- 20 – job -->
        <div class="info-numbered-row bangla-text-info">
            <div class="number">২০.</div>
            <div class="content">
            <div style="text-align: justify;">
            কোন চাকরিজীবী এ বিশ্ববিদ্যালয়ে ভর্তি হতে হলে তাকে তার চাকরির নিয়োগকারীর কাছ থেকে অবশ্যই ভর্তি হওয়ার অনুমতি ও ছুটি মঞ্জুরীর লিখিত অনুমতিপত্র এবং চাকরি হতে রিলিজ অর্ডার ( ছাড়পত্র ) গ্রহণ করতে হবে এবং মুল অনুমতি ও ছাড়পত্রের ( রিলিজ অর্ডার ) উপর সংশ্লিষ্ট বিভাগীয় সভাপতির লিখিত সুপারিশ ভর্তি ফরমের সাথে সংযুক্ত করে দিতে হবে। অন্যথায় তাকে ভর্তি করা হবে না। যদি ভর্তির সময় সংশ্লিষ্ট ছাত্র / ছাত্রী চাকুরিরত না থাকেন কিন্তু ভর্তির পর চাকুরি লাভ করেন তাহলেও এ বিশ্ববিদ্যালয়ে লেখাপড়া করার জন্য অনুরূপভাবে নিয়োগকারীর কাছ থেকে লিখিত অনুমতিপত্র ও ছুটি মঞ্জুরীর চিঠি এবং রিলিজ অর্ডার নিতে হবে। যদি এ ধরনের কোন তথ্য গোপন করে বা মিথ্যা তথ্য প্রদান করে কেউ ভর্তি হন, তা হলে তার ভর্তি বাতিল করা হবে এবং এজন্য তাকে অন্যান্য শাস্তিও ভোগ করতে হবে। চাকুরিরত হলে পদবী, প্রতিষ্ঠানের নাম ও ঠিকানা এবং নিয়োগকারীর পদবীসহ ঠিকানা উল্লেখ করতে হবে: 
                <span class="bangla-text-bold-info">${personal.is_employee ? '' : 'প্রযোজ্য নহে।'}</span>
            </div>
            
            <div class="ml-4">
                চাকরির বিবরণ: <strong class="${getLanguageClass(personal.job_description)}">${personal.is_employee ? personal.job_description : ''}</strong>
            </div>
            <div class="ml-4">
                নিয়োগকারীর বিবরণ: 
                <strong class="${getLanguageClass(personal.employer_details)}">${personal.is_employee ? personal.employer_details + '</strong>' : ''}</strong>
            </div>
            <div class="ml-4">
                ঠিকানা: <strong class="${getLanguageClass(personal.employer_address)}">${personal.is_employee ? personal.employer_address : ''}</strong>
            </div>
        
            </div>
        </div>


        <!-- 21 – instruction list -->
        <div class="info-numbered-row bangla-text-info">
            <div class="number">২১.</div>
            <div class="content">
            <div>
                <strong class="bangla-text-bold-info">বিশেষ নির্দেশনা</strong> :
                নিম্নলিখিত সনদপত্র ( সার্টিফিকেট ) এবং ভর্তির প্রয়োজনীয় অন্যান্য দলিলপত্রাদির ফটোকপি শিক্ষক বা গেজেটেড কর্মকর্তা দ্বারা সত্যায়িত করে এই ফরমের সংগে সংযুক্ত করে দিতে হবে। অন্যথায় ভর্তি করা হবে না। 
            </div>
            
            <div class="ml-1">
                (ক) সংশ্লিষ্ট শিক্ষাবোর্ড কতৃক ইস্যুকৃত মাধ্যমিক ও উচ্চ মাধ্যমিক বা সমমানের পরীক্ষা পাশের ট্রান্সক্রিপ্ট / গ্রেডশীট / নম্বরফর্দের সত্যায়িত ফটোকপি। 
            </div>
            <div class="ml-1">
                (খ) আবেদনকারীর সাম্প্রতিক তোলা তিন কপি পাসপোর্ট সাইজের সত্যায়িত ছবি।
            </div>
            <div class="ml-1">
                (গ) আই.ডি. কার্ড / রেজিস্ট্রেশন কার্ড / মাইগ্রেশন সার্টিফিকেট এর সত্যায়িত ফটোকপি ( যার জন্য প্রযোজ্য )। 
            </div>
            <div class="ml-1">
                (ঘ) ট্রান্সফার সার্টিফিকেট এর সত্যায়িত ফটোকপি ( যার জন্য প্রযোজ্য )। 
            </div>
            

            </div>
        </div>
      </div>




    </div> <!-- end page 2 -->

    <!-- PAGE 3 -->
    <div class="page page-a4">
    <div style="z-index:1; position:relative; min-height: 840px; padding: 10px 15px;">
        <img src="https://cu-admission.sgp1.cdn.digitaloceanspaces.com/logo/cu_watermark.png" class="watermark">

      

        <!-- Header -->
        <div class="section-lg mt-2 mb-3">
            <div class="bangla-text-bold">অঙ্গীকারপত্র</div>
        </div>

        <!-- Declaration -->
        <div class="bangla-text-bold section-content" style="text-align: justify;">
          <div class="section no-break">
              এতদ্বারা আমি ঘোষনা করছি যে, আমি এই ভর্তি ফরম নিজে সম্পূর্ণ পড়েছি এবং নিজ হাতে এই ভর্তি ফরম পূরণ করেছি। এই ভর্তি ফরমে প্রদত্ত সমস্ত বিবরন সত্য। আমি অঙ্গীকার করছি যে,
          </div>

          <div class="section indent">(ক) আমি এই বিশ্ববিদ্যালয়ের এবং হলের আবাসিক বা অনাবাসিক ছাত্র / ছাত্রী হিসেবে চট্টগ্রাম বিশ্ববিদ্যালয়ের সমস্ত নিয়ম ও বিধি মেনে চলব এবং বিশ্ববিদ্যালয়ের শান্তি-শৃঙ্খলা বা আদেশের পরিপন্থী কোন কাজ করবো না। যদি এই ধরনের কোন কাজ করি তবে বিশ্ববিদ্যালয় কর্তৃপক্ষ যে শাস্তি প্রদান করবেন তা বিনা আপত্তিতে মেনে নিতে বাধ্য থাকব।</div>

          <div class="section indent">(খ) যদি জাল বা ঘষামাজা করা কোন মার্কশীট বা সার্টিফিকেট বা দলিলপত্র দাখিল করার জন্য কিংবা প্রয়োজনীয় তথ্য গোপন বা মিথ্যা তথ্য প্রদান বা দ্বৈত ভর্তি হওয়ার কারণে আমি দোষী সাব্যস্ত হই তাহলে আমার ভর্তি বিশ্ববিদ্যালয় কতৃপক্ষ বাতিল করতে পারবেন। এছাড়া এই ব্যাপারে বিশ্ববিদ্যালয় কর্তৃপক্ষ অন্য যে কোন শাস্তি প্রদান করলে আমি মেনে নিতে বাধ্য থাকব।</div>

          <div class="section indent">(গ) ছাত্র / ছাত্রী হিসেবে আমার বিশ্ববিদ্যালয়ের ছাত্রত্ব সম্পর্কিত কোন বিষয়ে আমি চট্টগ্রাম বিশ্ববিদ্যালয়ের অ্যাক্ট ১৯৭৩ এর বিধানসমূহ, জরুরী আইনসমূহ অথবা সময়ে সময়ে প্রনীত বিধিসমূহ অথবা সিন্ডিকেট / একাডেমিক কাউন্সিল অথবা উপাচার্য / উপ-উপাচার্য / অনুষদের ডিনবৃন্দ কিংবা উক্ত বিষয়ে ভারপ্রাপ্ত কোন বিভাগীয় সভাপতি বা ইন্সটিটিউটের পরিচালক বা হলের প্রভোস্ট / প্রধান শিক্ষকের সিদ্ধান্ত চূড়ান্ত বলে মেনে নিতে বাধ্য থাকব।</div>

          <div class="section indent">(ঘ) বিশ্ববিদ্যালয়ে অধ্যয়নকালীন ও হলে অবস্থানকালীন সময়ে বিশ্ববিদ্যালয় কর্তৃপক্ষ প্রণিত ছাত্র-ছাত্রীদের অবশ্যই পালনীয় আচরণবিধি / সাধারণ ও সুনির্দিষ্ট নীতিমালার পরিপন্থী কোন কার্যকলাপে লিপ্ত থাকব না।</div>

          <div class="section indent">(ঙ) এই অঙ্গীকারপত্র স্বজ্ঞানে স্বাক্ষর দিলাম এবং আমার পিতা / মাতা/ স্বামী / আইনতঃ অভিভাবক স্বহস্তে স্বাক্ষর / টিপসই দান করেছেন।</div>
        </div>
        

        <!-- Signatures -->
        <div class="signature-row no-break bangla-text mt-4">
            <div class="signature-col">
                <div class="signature-line mt-2">_____________________________________</div>
                <div class="mt-2">( পিতা / মাতা / স্বামী / আইনতঃ অভিভাবকের স্বাক্ষর )</div>
                <div class="mt-2">তারিখঃ _____/_____/_______</div>
            </div>

            <div class="signature-col bagnla-text">
                <div class="signature-line mt-2">_____________________________________</div>
                <div class="mt-2">( আবেদনকারীর পুরো নামের স্বাক্ষর - বাংলায় )</div>
                <div class="mt-2">তারিখঃ _____/_____/_______</div>
            </div>
        </div>

        <!-- Dept & Provost -->
        <div class="approval-row bangla-text">
            <div style="width: 2%;"></div>
            <div class="approval-col-left">
                <div class="mt-2">বিভাগীয় সভাপতির মন্তব্যঃ ______________________________________</div>
                <div class="mt-2">____________________________________________________________________</div>
                <div class="mt-2"><strong>সভাপতি</strong>, _____________________________________________বিভাগ</div>
                <div style="margin-top: 100px;">____________________________________________________________</div>
                <div style="display:flex;flex-direction:column;align-items:center;">    
                    <div class="mt-2">( বিভাগীয় সভাপতির অফিস সীলসহ স্বাক্ষর )</div>
                    <div class="mt-2">তারিখঃ _____/_____/_______</div>
                </div>
                <div class="small-note" style="height:45px;margin-top: 10px;">
                    ভর্তির প্রয়োজনীয় সমস্ত মূল দলিলপত্রাধি যাচাইকৃত ও সঠিক আছে এবং ভর্তির নির্ধারিত সময়ও আছে। বিশ্ববিদ্যালয়ের নিয়ম অনুযায়ী সে ভর্তির যোগ্য।
                </div>
            </div>
            
            
            <div class="approval-col-right">
                <div class="mt-2">হল প্রভোস্টের মন্তব্যঃ ______________________________________</div>
                <div class="mt-2">____________________________________________________________</div>
                <div class="mt-2"><strong>প্রভোস্ট</strong>, ________________________________________________হল</div>
                <div style="margin-top: 100px;">_________________________________________________________</div>
                <div style="display:flex;flex-direction:column;align-items:center;">
                    <div class="mt-2">( হল প্রভোস্টের অফিস সীলসহ স্বাক্ষর )</div>
                    <div class="mt-2">তারিখঃ _____/_____/_______</div>
                </div>
                <div class="small-note" style="height:45px;margin-top: 10px;">
                &nbsp;
                </div>
            </div>
            
        </div>
        

        <!-- Registrar -->
        <div class="signature-row-3 no-break" style="margin-top: 70px;">
            <div class="signature-col-3">
              <div class="mt-2"><strong>--------------------------- </strong></div>
              <div class="mt-2 bangla-text-bold"><strong>ভর্তি সংশ্লিষ্ট সহকারী</strong></div>
            </div>
            <div class="signature-col-3">
                <div class="mt-2"><strong>---------------------------</strong></div>
                <div class="mt-2 bangla-text-bold"><strong>সহকারী রেজিস্ট্রার ( একাডেমিক )</strong></div>
                <div class="mt-2 bangla-text">রেজিস্ট্রার দপ্তর, চট্টগ্রাম বিশ্ববিদ্যালয়</div>
            </div>
            <div class="signature-col-3">
                <div class="mt-2"><strong>---------------------------</strong></div>
                <div class="mt-2 bangla-text-bold"><strong>ডেপুটি রেজিস্ট্রার ( একাডেমিক )</strong></div>
                <div class="mt-2 bangla-text">রেজিস্ট্রার দপ্তর, চট্টগ্রাম বিশ্ববিদ্যালয় </div>
            </div>
        </div>

    </div>
      
    </div> <!-- end page 3 -->

   

  </div>
</section>
</div>
`;
return html;
}